export default __webpack_public_path__ + "static/media/infiniwell_light_logo.7ddcc4e2.png";